import { createAsyncThunk } from '@reduxjs/toolkit';
import { LogParams } from '../Domain/Repositories/LogRepository';
import { LogRepositoryImpl } from '../Data/Repositories/LogRepositoryImpl';
import { GetLogsUseCase } from '../Domain/UseCase/GetLogsUseCase';
import { GetLogsPageUseCase } from '../Domain/UseCase/GetLogsPageUseCase';
import { GetLogsSummaryUseCase } from '../Domain/UseCase/GetLogsSummaryUseCase';
import { DeleteLogUseCase } from '../Domain/UseCase/DeleteLogUseCase';
import { UpdateLogUseCase } from '../Domain/UseCase/UpdateLogUseCase';
import { Log } from '../Model/Log';
import { User } from '../../User/Model/User';

const repo = new LogRepositoryImpl();

export const fetchLogs = createAsyncThunk('log/fetchAll', (params?: LogParams) =>
  new GetLogsUseCase(repo).execute(params),
);

export const fetchLogsPage = createAsyncThunk('log/fetchPage', (params: LogParams) =>
  new GetLogsPageUseCase(repo).execute(params),
);

export const fetchLogsForExport = createAsyncThunk('log/fetchForExport', (params?: LogParams) =>
  new GetLogsUseCase(repo).execute(params),
);

export const fetchLogsSummary = createAsyncThunk('log/fetchSummary', (params?: LogParams) =>
  new GetLogsSummaryUseCase(repo).execute(params),
);

// 오늘 로그 조회
export const fetchTodayLogs = createAsyncThunk('log/fetchToday', () =>
  new GetLogsUseCase(repo).execute({ filter_type: 'today' }),
);

// 어제 로그 조회
export const fetchYesterdayLogs = createAsyncThunk('log/fetchYesterday', () =>
  new GetLogsUseCase(repo).execute({ filter_type: 'yesterday' }),
);

// 이번달 로그 조회
export const fetchThisMonthLogs = createAsyncThunk('log/fetchThisMonth', () =>
  new GetLogsUseCase(repo).execute({ filter_type: 'this_month' }),
);

// 기간별 로그 조회
export const fetchCustomRangeLogs = createAsyncThunk(
  'log/fetchCustomRange', 
  (params: { start_date: string; end_date: string }) =>
    new GetLogsUseCase(repo).execute({ 
      filter_type: 'custom', 
      start_date: params.start_date, 
      end_date: params.end_date 
    }),
);

// 로그 삭제
export const deleteLog = createAsyncThunk(
  'log/delete',
  ({ logId, me }: { logId: number; me: User }) =>
    new DeleteLogUseCase(repo).execute(logId, me),
);

// 로그 일괄 삭제 (ADMIN 전용)
export const bulkDeleteLogs = createAsyncThunk(
  'log/bulkDelete',
  ({ logIds, me }: { logIds: number[]; me: User }) =>
    new DeleteLogUseCase(repo).executeBulk(logIds, me),
);

// 로그 수정 (로그 기록 없이, ADMIN)
export const updateLogWithoutRecord = createAsyncThunk(
  'log/updateWithoutRecord',
  ({ logId, payload }: { logId: number; payload: Partial<Pick<Log, 'action' | 'description' | 'final_days' | 'end_date' | 'total_days' | 'start_date'>> }) =>
    new UpdateLogUseCase(repo).execute(logId, payload)
);

// 서버 엑셀 다운로드
export const downloadLogsExcel = createAsyncThunk(
  'log/downloadExcel',
  async () => {
    const blob = await repo.downloadExcel();
    return blob;
  }
);
